export enum OrderState {
  CART = 'cart',
  GUEST_CART = 'guest_cart',
  TEMPORARY_CART = 'temporary_cart',
  CURRENT_QUOTATION = 'current_quotation',
  SAVED_QUOTATION = 'saved_quotation',
  PURCHASED_QUOTATION = 'purchased_quotation',
  BOOKED = 'booked',
  CONFIRMED = 'confirmed',
  REJECTED = 'rejected',
  DELIVERED = 'delivered',
  CANCELLED = 'cancelled',
  RETURNED = 'returned',
  PARTIAL_SHIPPED = 'partial shipped',
  SHIPPED = 'shipped',
  PAYMENT_INITIATED = 'payment_initiated', // new status introduced in Wakanda
  FAILED = 'failed', // new status introduced in Wakanda
}
